// CustomFormPage.tsx

import React from "react";
import CustomMenu from "../../components/CustomMenu/CustomMenu";
import { CustomFormContainer } from "./CustomFormContainer";

/**
 * カスタムフォームページコンポーネント
 * - カスタムメニュー内に申請フォームを表示する
 */
export const CustomFromPage = () => {
  return (
    <CustomMenu>
      <CustomFormContainer />
    </CustomMenu>
  );
};

export default CustomFromPage;
